import { styled } from "@mui/material/styles";
import { Box, Grid } from "@mui/material";

export const RegisterForm = styled(Box)(({ theme }) => ({
  paddingTop: theme.spacing(2),
}));

export const RegisterFormGrid = styled(({ children }) => (
  <Grid container>
    {children}
  </Grid>
))(({ theme }) => ({
  spacing: 2,
}));
